import { useContext } from "react";
import { TableContext } from "../..";
import Header from "./Header";
import Body from "./Body";

export default function Desktop() {
  const table = useContext(TableContext);

  return (
    <table
      dir="rtl"
      className="border-separate border-spacing-0"
      style={{ width: "100%", ...table.tableStyles }}
    >
      {table.headers && <Header />}
      <Body key={table.bodyChangeKey} />
    </table>
  );
}
